import React from "react";
import { useTranslation } from "react-i18next";
import { countryLists } from "../config";

const Tabs = ({ activeTab, setActiveTab }) => {
  const { t } = useTranslation();
  return (
    <div className="c-tab-nav j-tab-nav">
      <ul>
        {countryLists.map(({ code, label }) => {
          const isActive = code === activeTab;
          return (
            <li
              className={isActive ? "is-active" : ""}
              key={code}
              onClick={() => setActiveTab(code)}
            >
              <button aria-expanded={isActive}>{t(label)}</button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Tabs;
